import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

import { getBusinessLogoProps } from './HeaderHomeBusiness.utils'

export interface HeaderHomeBusinessProps {
  displayHearme: boolean
}

export const HeaderHomeBusiness = ({ displayHearme }: HeaderHomeBusinessProps) => {
  const { desktopProps, mobileProps } = getBusinessLogoProps(displayHearme)

  return (
    <Link href="/business">
      <Image {...desktopProps} alt={desktopProps.alt} className="hidden text-primary laptop:block" />
      <Image {...mobileProps} alt={mobileProps.alt} className="block text-primary laptop:hidden" />
    </Link>
  )
}
